import React, { useState, useEffect } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';

export default function NoListEditor({value, returnChange, height = true}) {
  const [content, setContent] = useState(value)

  useEffect(() => {
    setContent(value)
  }, [value])

  useEffect(() => {
    returnChange(content)
  }, [content])

  let modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false]}],
      ["bold", "italic", "underline", "strike"],
      ["link", "image", "video"]
    ]
  }

  return (
    <div>
      {height &&
        <div style={{height: '400px', maxHeight: '500px', overflow: 'auto'}}>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            className="editor-state text-editor-height"
            modules={modules}
          />
        </div>
      }

      {!height &&
        <div style={{height: 'fit-content', maxHeight: '500px', overflow: 'auto'}}>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
          className="editor-state"
            modules={modules}
          />
        </div>
      }
    </div>
  )
}
